module.exports = __webpack_public_path__ + "img/Skirt Barn, 1950.e67a8ea4.jpg";